/*
 * Part of the RubinRed CMS.
 * @author    Paolo Pontarollo <pontarollo@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.com
 */

import VueI18n from 'vue-i18n';
import Vue from 'js/vendor/vue';
import translations from 'js/translations';
import LaravelFormatter from 'js/utils/LaravelFormatter';

//TODO: override method to work with laravel format
// "{0} There are no apples|{1} There is one apple|]1,Inf] There are %count% apples"

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {

  let options = message.split('|');
  //handle single case
  if(options.length == 1) {
    return message;
  }
  //ye old vanilla for loop
  for(let i = 0; i < options.length; i++) {
    //check for single number
    let regExp = /[^{\}]+(?=})/g;
    let matches = options[i].match(regExp);
    if(matches && matches.length > 0) {
      if(choice == parseInt(matches[0])) {
        return options[i].replace(/ *\{[^}]*\} */g, "").trim();
      }
    }
    //check for range
    regExp = /\[(.*?)\]/;
    matches = options[i].match(regExp);
    if(matches && matches.length > 1) {
      let values = normalizeInterval(matches[1].split(','));
      if(values.length == 2 && values[0] <= choice && values[1] >= choice) {
        return options[i].replace(/ *\[[^]*\] */g, "").trim();
      }
    }

    regExp = /\](.*?)\[/;
    matches = options[i].match(regExp);
    if(matches && matches.length > 1) {
      let values = normalizeInterval(matches[1].split(','));
      if(values.length == 2 && values[0] < choice && values[1] > choice) {
        return options[i].replace(/ *\][^]*\[ */g, "").trim();
      }
    }

    regExp = /\[(.*?)\[/;
    matches = options[i].match(regExp);
    if(matches && matches.length > 1) {
      let values = normalizeInterval(matches[1].split(','));
      if(values.length == 2 && values[0] <= choice && values[1] > choice) {
        return options[i].replace(/ *\[[^]*\[ */g, "").trim();
      }
    }

    regExp = /\](.*?)\]/;
    matches = options[i].match(regExp);
    if(matches && matches.length > 1) {
      let values = normalizeInterval(matches[1].split(','));
      if(values.length == 2 && values[0] < choice && values[1] >= choice) {
        return options[i].replace(/ *\][^]*\] */g, "").trim();
      }
    }
  }
};

function normalizeInterval(values) {
  if(values.length == 2) {
    if(values[0] == "Inf") {
      values[0] = Number.NEGATIVE_INFINITY;
    } else {
      values[0] = parseInt(values[0]);
    }

    if(values[1] == "Inf") {
      values[1] = Number.POSITIVE_INFINITY;
    } else {
      values[1] = parseInt(values[1]);
    }
  }
  return values;
}

Vue.use(VueI18n);

export default new VueI18n({
  formatter: new LaravelFormatter(),
  messages: translations,
});



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/vendor/vue-i18n.js